import React from 'react'
import { Input, Button, Space, Tooltip, Typography } from 'antd'
import { DeleteOutlined, FunctionOutlined } from '@ant-design/icons'
import { RawNode } from '../types'
import { validateExpression } from '../expression'

const { Text } = Typography

type Props = {
  node: RawNode
  onChange: (node: RawNode) => void
  onRemove: () => void
}

/**
 * Editor for a free-form boolean expression (method/function calls, arrows, etc.)
 * that has no structured field/operator/value form. Edited as raw JS text, with
 * inline syntax validation so an invalid snippet can't silently corrupt the output.
 */
export default function ExpressionRaw({ node, onChange, onRemove }: Props) {
  const error = validateExpression(node.source)

  return (
    <div>
      <Space align='baseline' style={{ width: '100%' }}>
        <Tooltip title='Custom expression'>
          <FunctionOutlined style={{ color: '#999' }} />
        </Tooltip>
        <Input
          style={{
            minWidth: 360,
            fontFamily: 'monospace',
            borderColor: error ? '#ff4d4f' : undefined
          }}
          value={node.source}
          placeholder='e.g. $pet.attr.options.some(v => v.key == "foo")'
          onChange={e => onChange({ ...node, source: e.target.value })}
        />
        <Button
          type='text'
          danger
          icon={<DeleteOutlined />}
          onClick={onRemove}
          title='Remove expression'
        />
      </Space>
      {error && (
        <Text type='danger' style={{ display: 'block', marginLeft: 24, fontSize: 12 }}>
          {error}
        </Text>
      )}
    </div>
  )
}
